export interface Tag {
    id: number;
    name: string;
}

export interface TagWithCount {
    id: number;
    name: string;
    count: number;
    draftCount: number;
}

export interface TemplateTag {
    id: number;
    template: number;
    tag: Tag;
}
